import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/src/layouts/checkout.vue").then(m => m.default || m)),
  "checkout-rooms": defineAsyncComponent(() => import("/src/layouts/checkoutRooms.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/layouts/default.vue").then(m => m.default || m)),
  loyalty: defineAsyncComponent(() => import("/src/layouts/loyalty.vue").then(m => m.default || m)),
  "thank-you": defineAsyncComponent(() => import("/src/layouts/thankYou.vue").then(m => m.default || m))
}